import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Wrapper from './style';
import { Button, Select, message } from 'antd';
import GetXht from '../../components/GetXht';
import { HEX_LOGO_WHITE } from '../../config/media';
import { createWalletAddress } from '../../common/fetch';
import Advantages from './advantages.json';

const { Option } = Select;

class LearnMore extends Component {
	state = {
		visible: false,
		currency: 'btc',
		isLoading: false,
		crypto_wallet: this.props.user.crypto_wallet,
		type: 0
	};

	handleChangeSelect = (c) => {
		this.setState({ currency: c });
	};

	handleClick = () => {
		const { currency, crypto_wallet } = this.state;
		const { user, actions } = this.props;
		if (crypto_wallet[currency] === undefined) {
			this.setState({ isLoading: true }, async () => {
				try {
					const res = await createWalletAddress(currency);
					user.crypto_wallet[currency] = res.data.address;
					actions.updateData(user);
					this.setState({
						visible: true,
						isLoading: false
					});
				} catch (error) {
					if (error.data.message.indexOf('already') >= 0) {
						this.setState({
							visible: true,
							isLoading: false
						});
					} else {
						message.error(error.data.message);
					}
				}
			});
		} else {
			this.setState({ visible: true });
		}
	};

	handleCancel = () => {
		this.setState({ visible: false });
	};

	renderOptions = () => {
		const { coin } = this.props;
		const List = coin.map((item) => (
			<Option value={item.value} key={item.value}>
				{item.key}
			</Option>
		));
		return List;
	};

	renderList = () => {
		return Advantages.list.map((item) => (
			<div className="learn-card">
				<div
					className="learn-card-image"
					style={{ backgroundImage: `url(${item.img})` }}
				/>
				<h4>{item.title}</h4>
				<p>
					<b>{item.subTitle}</b>
					<br />
					{item.description}
				</p>
				<a
					href={item.link}
					title={item.title}
					target="_blank"
					rel="noopener noreferrer"
				>
					Learn More
				</a>
			</div>
		));
	};

	render() {
		const { visible, currency, isLoading } = this.state;
		return (
			<Wrapper>
				<div className="payment-header">
					<img src={HEX_LOGO_WHITE} alt="logo" className="img-logo" />
					<div className="payment-header-container">
						<h3>
							<b>Charge Balance</b>
						</h3>
						<p>Charge account with:</p>
						<div className="select-account">
							<Select
								value={currency}
								style={{ width: '100%' }}
								onChange={this.handleChangeSelect}
							>
								{this.renderOptions()}
							</Select>
							<Button
								type="primary"
								onClick={this.handleClick}
								block
								disabled={isLoading}
							>
								Charge
							</Button>
						</div>
						<p className="links">
							Already have XHT?{' '}
							<span onClick={this.props.checkDeposit}>
								Deposit XHT here.
							</span>
						</p>
					</div>
				</div>
				<div className="credit-info">
					<h2>
						Pay for exchange software and other services directly through
						HollaEx Token (XHT)
					</h2>
					<p>
						You can use XHT to access bitHolla products such as the
						exchange software HollaEx Kit. Don't have XHT? Simply charge
						your account below with a crypto of your choice and have it
						automatically converted into XHT.
					</p>
					<Link to="/help">Learn More</Link>
				</div>
				<div className="learn-container">
					<h2>XHT Advantage</h2>
					{this.renderList()}
				</div>
				{visible ? (
					<GetXht
						visible={true}
						handleCancel={this.handleCancel}
						handleOk={this.handleOk}
						currency={currency}
						step={2}
					/>
				) : null}
			</Wrapper>
		);
	}
}

export default LearnMore;
